import { PDLButton, PDLTypography } from "../../dna";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { doLogin } from "../../../../store/reducer/_sessionReducer";
import Form from "react-bootstrap/Form";
import { getLoggedIn } from "../../../../store/selectors";
import { Logo } from "../../global";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router";
import "./index.scss";

const LoginForm = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const loggedIn = useSelector(getLoggedIn);
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);

  const handleLogin = useCallback(async () => {
    dispatch(
      doLogin({
        email,
        password,
      })
    );
  }, [dispatch, email, password]);

  const redirectToHome = useCallback(() => {
    navigate("/home");
  }, [navigate]);

  useEffect(() => {
    if (loggedIn) {
      redirectToHome();
    }
  }, [loggedIn, redirectToHome]);

  return (
    <div className="pdl_component_loginform">
      <Logo variant="login" className="mb-5" />
      <Form className="d-grid gap-5">
        <div className="d-grid gap-1">
          <PDLTypography display size="md" weight="semibold">
            Acesse sua conta
          </PDLTypography>
          <PDLTypography size="md">
            Olá novamente! Por favor, insira seus dados para continuar.
          </PDLTypography>
        </div>
        <div className="d-grid gap-4">
          <div className="d-grid gap-3">
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control
                value={email}
                onChange={(evt) => setEmail(evt.target.value)}
                autoComplete="email"
                type="text"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Senha</Form.Label>
              <Form.Control
                value={password}
                onChange={(evt) => setPassword(evt.target.value)}
                autoComplete="current-password"
                type="password"
              />
            </Form.Group>
          </div>
          <div className="d-flex align-items-center justify-content-between">
            <Form.Check
              type="checkbox"
              label="Lembrar meus dados"
              checked={remember}
              onChange={(evt) => setRemember(evt.target.checked)}
            />
            <NavLink to="/recuperarSenha">Esqueci a senha</NavLink>
          </div>
          <div className="d-grid gap-3">
            <PDLButton
              type="button"
              variant="primary"
              onClick={handleLogin}
              size="lg"
            >
              Entrar
            </PDLButton>
            <PDLButton type="button" variant="tertiary" size="lg">
              Continuar com Google
            </PDLButton>
          </div>
        </div>
        <PDLTypography size="sm" className="text-center">
          Não tem uma conta? <NavLink to="/criarConta">Criar conta</NavLink>
        </PDLTypography>
      </Form>
    </div>
  );
};

export default LoginForm;
